import {
  Card,
  Stack,
  Group,
  Title,
  Badge,
  Text,
  Anchor,
  Code,
  ActionIcon,
  CopyButton,
  Tooltip,
} from '@mantine/core'
import { IconExternalLink, IconCopy, IconCheck } from '@tabler/icons-react'
import type { AppItem } from '../../api/apps'

const ENV_COLORS: Record<AppItem['environment'], string> = {
  DEV: 'gray',
  QA: 'blue',
  HML: 'orange',
  PRD: 'red',
}

export default function AppCard({ app }: { app: AppItem }) {
  return (
    <Card withBorder padding="md" radius="md" data-testid={`app-card-${app.slug}`}>
      <Stack gap="sm">
        <Group justify="space-between">
          <Title order={4}>{app.display_name}</Title>
          <Badge color={ENV_COLORS[app.environment]} variant="light">
            {app.environment}
          </Badge>
        </Group>
        <Text size="sm" c="dimmed">
          {app.hostname}
        </Text>
        <Group gap="xs">
          <Badge variant="outline" size="sm">
            {app.protocol.toUpperCase()}
          </Badge>
          <Badge variant="outline" size="sm">
            {app.routing_mode}
          </Badge>
          <Badge variant="outline" size="sm">
            identity={app.identity_mode}
          </Badge>
        </Group>
        {app.access_url && (
          <Anchor href={app.access_url} target="_blank" rel="noopener noreferrer">
            <Group gap={4}>
              Abrir
              <IconExternalLink size={14} />
            </Group>
          </Anchor>
        )}
        {app.cli_command && (
          <Group gap="xs">
            <Code>{app.cli_command}</Code>
            <CopyButton value={app.cli_command}>
              {({ copied, copy }) => (
                <Tooltip label={copied ? 'Copiado' : 'Copiar'}>
                  <ActionIcon variant="subtle" onClick={copy}>
                    {copied ? <IconCheck size={14} /> : <IconCopy size={14} />}
                  </ActionIcon>
                </Tooltip>
              )}
            </CopyButton>
          </Group>
        )}
      </Stack>
    </Card>
  )
}
